<label class="input-search" [ngClass]="{ 'mobile-mode': mobileMode, 'theme-light': theme === 'light', 'size-large': size === 'large' }">
  <nb-icon icon="search" pack="icomoon" class="input-search-icon"> </nb-icon>
  <input
    [defaultValue]="defaultValue"
    type="text"
    [placeholder]="placeholder ?? '' | t"
    class="input-search-input"
    [(ngModel)]="searchInputModel"
    (input)="handleInput()" />
  <!--  <div-->
  <!--    class="input-search-info"-->
  <!--    placement="top"-->
  <!--    [ngbTooltip]="'min_length_2' | t"-->
  <!--    *ngIf="searchInputModel.length > 0 && searchInputModel.length < 2 && showMinLengthIcon">-->
  <!--    <nb-icon icon="info" pack="icomoon" class="input-search-info-icon"></nb-icon>-->
  <!--  </div>-->
  <button (click)="clearInput($event)" class="input-search-basket" *ngIf="searchInputModel.length > 0">
    <nb-icon icon="basket-filled" pack="icomoon" class="input-search-basket-icon"></nb-icon>
  </button>
</label>
